import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn } from '@angular/forms';
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { Moment } from 'moment';


export interface DateRangeFilter {
  startDate: Moment | null;
  endDate: Moment | null;
}

export const dateRangeValidator: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
  const start = group.get('startDate')?.value;
  const end = group.get('endDate')?.value;

  if(!start || !end) return null;
  return start <= end ? null : { dateRangeInvalid: true };

}

@Component({
  selector: 'app-date-range-filter',
  imports: [ReactiveFormsModule, MatDatepickerModule, MatFormFieldModule, MatButtonModule, MatNativeDateModule, MatInputModule, CommonModule, MatIconModule, MatCardModule],
  templateUrl: './date-range-filter.component.html',
  styleUrl: './date-range-filter.component.scss'
})
export class DateRangeFilterComponent implements OnInit {
  @Output() filterChange = new EventEmitter<DateRangeFilter>();

  form!: FormGroup;

  constructor(private readonly fb: FormBuilder){}

  ngOnInit(): void {
    this.form = this.fb.group({
      startDate: [null],
      endDate: [null]
    },
    {
      validators: dateRangeValidator
    });
  }

  changeDate() {
    this.filterChange.emit(this.form.value);
  }

  reset(): void {
    this.form.reset({startDate: null, endDate: null});
    this.changeDate();
  }

  clearStartDate(): void {
    this.form.get('startDate')?.setValue(null);
    this.changeDate();
  }

  clearEndDate(): void {
    this.form.get('endDate')?.setValue(null);
    this.changeDate();
  }
}
